import {
  ORDER_SET_ORDERS,
  ORDER_CHANGE_VALUE,
  ORDER_CHANGE_VALUES,
  ORDER_CHANGE_ACTIVE_TAB,
  ORDER_CHANGE_TABLE_OPTION,
  ORDER_CHANGE_TABLE_OPTIONS,
  ORDER_DETAIL_EDIT_ORDER,
  ORDER_CHECKOUT_COMPLETE,
  ADMIN_LOGOUT,
} from '@shared/store/constants/mutationTypes';
import initialState from './orderInitialState';

const mutations = {
  [ORDER_CHANGE_VALUE]: (state, payload) => {
    const {
      field,
      value,
    } = payload;
    state[field] = value;
  },
  [ORDER_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
  [ORDER_CHANGE_ACTIVE_TAB]: (state, payload) => {
    const {
      tab,
    } = payload;
    state.activeTab = tab;
    state.selectedCorporation = 'all';
  },
  [ORDER_SET_ORDERS]: (state, payload) => {
    const {
      customerOrders,
      partnerOrders,
      partnerCorporation,
    } = payload;
    state.customerOrders = Object.freeze(customerOrders);
    state.partnerOrders = Object.freeze(partnerOrders);
    state.partnerCorporation = partnerCorporation;
    state.loading = false;
  },
  [ORDER_DETAIL_EDIT_ORDER]: (state, payload) => {
    const {
      order,
    } = payload;
    const {
      customerOrders,
      partnerOrders,
      activeTab,
    } = state;
    if (order.customer) {
      const orderIdx = customerOrders.reduce((acc, o, idx) => {
        let index = acc;
        if (order.orderNumber === o.orderNumber) {
          index = idx;
        }
        return index;
      }, -1);
      if (orderIdx !== -1) {
        const newCustomerOrders = customerOrders.slice();
        newCustomerOrders[orderIdx] = {
          ...order,
          expanded: false,
        };
        state.customerOrders = Object.freeze(newCustomerOrders);
        if (activeTab === 'customer') {
          state.tableData = Object.freeze(newCustomerOrders);
        }
      }
    } else if (order.corporation) {
      const orderIdx = partnerOrders.reduce((acc, o, idx) => {
        let index = acc;
        if (order.orderNumber === o.orderNumber) {
          index = idx;
        }
        return index;
      }, -1);
      if (orderIdx !== -1) {
        const newPartnerOrders = partnerOrders.slice();
        newPartnerOrders[orderIdx] = {
          ...order,
          expanded: false,
        };
        state.partnerOrders = Object.freeze(newPartnerOrders);
        if (activeTab === 'partner') {
          state.tableData = Object.freeze(newPartnerOrders);
        }
      }
    }
  },
  [ORDER_CHANGE_TABLE_OPTION]: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    if (typeof value === 'object') {
      if (value.includes(undefined)) {
        state.orderTableOptions.sortBy = [];
        state.orderTableOptions.sortDesc = [];
      }
    }
    state.orderTableOptions[field] = value;
  },
  [ORDER_CHANGE_TABLE_OPTIONS]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      if (typeof value === 'object') {
        if (value.includes(undefined)) {
          state.orderTableOptions.sortBy = [];
          state.orderTableOptions.sortDesc = [];
        }
      }
      state.orderTableOptions[field] = value;
    });
  },
  [ORDER_CHECKOUT_COMPLETE]: (state) => {
    state.processingOrder = false;
    state.showActionModal = false;
    state.newOrder = {};
  },
  [ADMIN_LOGOUT]: (state) => {
    Object.assign(state, initialState());
  },
};

export default mutations;
